<template>
    <div class="home-component">
        <div class="enter-membership-form">
            <div class="upcoming-events-title">
                予約完了です。<br>お待ちしております!
            </div>

            <div class="upcoming-events-subtitle">
                ELEVATEの体験を友人と共有しませんか？
            </div>

            <button type="button" @click="shareEventClicked" class="session-detail-component-contents-right-column-payment-sign-up">Share the event</button>

            <!-- <div class="upcoming-events-date">
                招待コードを使用して友人がELEVATEアカウントにサインアップすると、イベントが10%オフになるクーポンをお互いに受け取ることができます。
            </div> -->

            <!-- <div class="invitation-code-container-container">
                <div class="referral-code-title">
                    招待コード
                </div>
                <div class="invitation-code-container" id="invitation-code-container">
                    
                </div>
            </div> -->


        </div>
        
    </div>
</template>

<style scoped>

.home-component {
    min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        /* padding-top: 20pt; */
        margin-top: -100px;
        /* background-image: url("./../../assets/elevate-tiling.png"); */
}

.session-detail-component-contents-right-column-payment-sign-up {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 8px;
    margin-bottom:16px;
    height: 40px;
    width: 300px;
    cursor:pointer;
    background-color: rgb(225, 228, 118);
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    margin-top: 40px;
    margin-bottom: 50px;
}

.session-detail-component-contents-right-column-payment-sign-up:hover {
  background: #9c9e2b;
}

.text-container {
    text-align: left;
}

.invitation-code-container-container {
    display: flex;
    flex-direction: column;
}

.referral-code-title {
    color: white;
    font-family:  SFPRoSemiBold;
    margin-top: 30px;
    text-align: center;
}
.invitation-code-container {
    background-color: rgb(225, 228, 118);
    width: 300px;
    height: 70px;
    margin-bottom: 30px;
    margin-top: 5px;
    border-radius: 8px;
    font-family: OxygenRegular;
    color: black;
    line-height: 70px;
    font-size: 19pt;
    text-align: center;
}

.waiver-check-box-container {
    margin-left: 20px;
    font-family:  SFPRoRegular;
        font-size: 12pt;
        color: white;
}

.hr {
    display: none;
}

.divider {
    margin-left: 20px;
    margin-right: 20px;
}

.sign-up-container {
    display: flex;
    justify-content: space-between;
}

    .sign-up {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 20px;
        margin-bottom:16px;
        height: 40px;
        cursor:pointer;
        background-color: rgb(225, 228, 118);
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 200px
    }

    .sign-up:hover {
        background: #9c9e2b;
    }   


    .upcoming-events-gallery {
        display: grid;
        grid-area: 1 / 1;
        grid-template-columns: 320px 1fr 320px 1fr;
        grid-gap: 40px;
    }

    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        background: none; 
        border: none;
    }

    .upcoming-events-title {
        font-family:  SFPRoSemiBold;
        font-size: 30pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-right: 20px;
        padding-bottom: 40px;
        text-align: center;
    }

     .upcoming-events-subtitle {
        font-family:  SFPRoRegular;
        font-size: 22pt;
        padding-left: 20px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-top: 0px;
        color: white;
    }

    .upcoming-events-coupons {
        font-family:  SFPRoSemibold;
        font-size: 22pt;
        padding-left: 20px;
        padding-top: 20px;
        padding-bottom: 10px;
        padding-right: 20px;
        color: white;
    }

    .upcoming-events-coupons-subtitle {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        padding-left: 20px;
        padding-bottom: 28px;
        padding-right: 20px;
        color: white;
    }

    .upcoming-events-date {
        font-family:  SFPRoRegular;
        font-size: 14pt;
        padding-left: 20px;
        padding-bottom: 20px;
        padding-right: 20px;
        color: white;
        text-align: center;
    }
    
    .next-event-photo {
        width: 300px;
        height: 300px;
        border-radius: 12pt;
        object-fit: cover;
        cursor: pointer;
    }

    .event-subtitle {
        padding-bottom: 10px;
    }

    .event-photo {
        overflow: hidden;  
        border-radius: 12pt;
        background-color: red;  
        background: none; 
        border: none;
    }

    .event-date {
        color: white;
        font-size: 14pt;
        font-family:  SFPRoLight;
        padding-bottom: 10px;
        padding-top: 4px;
    }

.event-title {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoSemiBold;
    }

    .next-event-photo:hover {
    transform: scale(1.05); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
    }
    
    .next-event-photo {
        
    display: block;
    transition: transform .4s;   /* smoother zoom */
}

    .event-subtitle {
        color: white;
        font-size: 16pt;
        font-family:  SFPRoRegular;
    }

    .nav-buttons {
        padding-right: 16px;
        display: flex;
        gap: 10px;
    }

    .enter-membership-form {
        background-color: rgb(35,32,38);
        /* display: flex; */
        width:auto;
        margin-left:15px;
        margin-right:15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 50px;
        padding-bottom: 20px;
        background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
        border-radius: 10px;
    }

    .upcoming-events-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
    }

    .your-account-nav-bar {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 18pt;
        margin-left: 16px
    }

    .upcoming-events-title {
        color: white;
    }

    .home-component {
        min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 20pt;
    }

    .waiver-link {
        color: white;
        font-family:  SFPRoRegular;
        font-size: 14pt;
    }

    .button-container {
        display: flex;
         justify-content: center;
         margin-top: 35pt;
    }

    .session-detail-component-header-logo {
        height: 100pt;
        align-items: left;
        object-fit: contain;
        display: flex;
        justify-content: left;
        padding-left: 20pt;
    }

    .app-header {
        height: 100pt;
        width: 100%;
        justify-content: space-between;
        align-items: left;
        display: flex;
        
    }

    .app-header-nav-bar {
        height: 10pt;
        width: auto;
        justify-content: space-between;
        align-items: left;
        padding-right: 10pt;
        display: flex;
    }
    
    .membership-number-text-field {
        height: 35px;
        font-family:  SFPRoRegular;
        font-size: 14pt;
        box-sizing: border-box;
    }

    .home-component-elevate-title {
        font-family: SFPRoBold;
        font-size: 16pt;
    }

    .membership-number-text-field-label {
        font-family: SFPRoBold;
        color: white;
        padding-top: 15pt;
    }

    .membership-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .password-number-text-field {
        width: 100%;
        margin-bottom: 2pt;
        margin-top: 6pt;
    }

    .membership-number-text-field-sub-label {
        font-family: SFPRoRegular;
        color: white;
        font-size: 12pt;
        margin-bottom: 20pt;
        margin-top: 4pt;
    }

    .membership-number-submit {
        height: 40px;
        background-color: rgb(225, 228, 99);
        cursor: pointer;
        border: none;
        border-radius: 8px;
        color: black;
        font-family: SFPRoBold;
        font-size: 16px;
        transition: 300ms;
        width: 150pt;
        align-items: center;
        justify-content: center;
    }

    @media only screen and (max-width: 1000px) {
        .container {
        display: flex;
        flex-direction: column;
   }
}

@media only screen and (max-width: 1000px) {
   .upcoming-events-gallery {
        grid-template-columns: 1fr;
   }

   .hr {
    display: flex;
    width: 100%;
}
}

@media only screen and (max-width: 1000px) {
    .upcoming-event-feb-2 {
        padding-left: 20px;
        display: flex;
        flex-direction: row;
    }
    
    .next-event-photo {
        width: 100px;
        height: 100px;
        margin-right: 10px;
    }
}



.sign-up-for-membership-page {
    font-family: SFPRoRegular;
    color: white;
    font-size: 14pt;
    margin-top: 5pt;
}

.member-log-in-title {
    font-family: SFPRoBold;
    color: white;
    font-size: 18pt;
    margin-top: 50pt;
    text-align: left;
    display: flex;
}

</style>

<script setup>
    // import { useRouter } from "vue-router";
    // import { store } from '../../store.js'
    // import { useUserStore } from "@/piniastore";
    // const userStore = useUserStore();
    // const router = useRouter();

    async function shareEventClicked() { 

        if (navigator.share) {
      try {
        await navigator.share({
          title: 'Sauna+Ice Bath: Social', // The title of the content that will be shared.
          text: '行くよ このイベントをチェック！', // The text that will accompany the content.
          url: 'https://elevatebreathwork.netlify.app/session-detail-march-24', // The URL to the event or content you want to share.
        });
        console.log('Event shared successfully');
      } catch (error) {
        console.error('Error sharing the event', error);
      }
    } else {
      // Fallback for browsers that don't support the Web Share API
      alert('Web share is not supported in this browser.');
    }
  
     } 
</script>

<script>
// import { onMounted } from "vue";
export default {
    
    mounted () {
        window.scrollTo(0, 0);
    }
}
</script>
